<template>
  <div style="min-height: 100vh">
    <NavBar />
    <MarqueeTicker />
    <main class="animate-fade-in search-main-layout">
      <NuxtPage />
    </main>
    <AppFooter />
    <MobileBottomNav />
  </div>
</template>
